exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-bar {\n  display: flex;\n  padding: 0;\n  justify-content: flex-start;\n  width: 100%;\n}\n.search-bar i {\n  color: rgba(0, 0, 0, 0.26);\n}\n.search-bar .ant-input-affix-wrapper {\n  width: 100%;\n  padding: 0 12px;\n  border-radius: 6px;\n}\n.search-bar .ant-input-affix-wrapper .ant-input {\n  width: 100%;\n  border: solid 1px rgba(0, 0, 0, 0.12);\n  font-weight: normal;\n  font-size: 14px;\n  padding-left: 8px;\n}\n.search-bar .ant-input-affix-wrapper .ant-input::placeholder {\n  color: rgba(0, 0, 0, 0.26);\n  margin-left: 8px;\n  font-weight: normal;\n}\n", ""]);

// exports
